import { FormFieldTypes, validationTypes } from "@repo/design-system/components/forms/libs";

// HSC (12th) stream options — sent to the API as streamId / streamName
export const STREAM_OPTIONS = [
  { value: 1, label: "Science" },
  { value: 2, label: "Commerce" },
  { value: 3, label: "Arts" },
  { value: 4, label: "Other" },
];

// Stream is only part of the HSC (12th) record.
// Built lazily so FormFieldTypes isn't read at module load (circular import → undefined).
const getStreamField = () => ({
  id: "stream",
  label: "Stream",
  Field_Name: "Stream",
  fieldType: FormFieldTypes.SELECT,
  dataField: "stream",
  fieldSetting: { placeholder: "Select stream", options: STREAM_OPTIONS, isSearchable: false },
  validation: [{ type: validationTypes.REQUIRE }],
  style: { containerCss: "col-6 mb-2" },
});

export const buildAcademicRecordFormConfig = ({ isHsc = false } = {}) => ({
  name: "Academic Record Form",
  initialState: {
    boardName: "",
    schoolName: "",
    seatNo: "",
    passingYear: "",
    percentage: "",
    ...(isHsc ? { stream: "" } : {}),
  },
  section: [
    {
      title: "",
      style: { sectionStyle: "" },
      rowGroup: [
        {
          style: { groupStyle: "row" },
          fields: [
            {
              id: "boardName",
              label: "Board Name",
              Field_Name: "Board Name",
              fieldType: FormFieldTypes.SELECT,
              dataField: "boardName",
              fieldSetting: { placeholder: "Select board", options: [], isSearchable: true },
              validation: [{ type: validationTypes.REQUIRE }],
              style: { containerCss: "col-6 mb-2" },
            },
            {
              id: "schoolName",
              label: "School Name",
              Field_Name: "School Name",
              fieldType: FormFieldTypes.INPUT,
              dataField: "schoolName",
              fieldSetting: { placeholder: "Enter school name" },
              validation: [{ type: validationTypes.REQUIRE }],
              style: { containerCss: "col-6 mb-2" },
            },
          ],
        },
        {
          style: { groupStyle: "row" },
          fields: [
            {
              id: "seatNo",
              label: "Seat Number",
              Field_Name: "Seat Number",
              fieldType: FormFieldTypes.INPUT,
              dataField: "seatNo",
              fieldSetting: { placeholder: "Enter seat number", maxLength: 30 },
              validation: [{ type: validationTypes.REQUIRE }],
              style: { containerCss: "col-6 mb-2" },
            },
            {
              id: "passingYear",
              label: "Passing Year",
              Field_Name: "Passing Year",
              fieldType: FormFieldTypes.SELECT,
              dataField: "passingYear",
              fieldSetting: { placeholder: "Select passing year", options: [], isSearchable: true },
              validation: [{ type: validationTypes.REQUIRE }],
              style: { containerCss: "col-6 mb-2" },
            },
          ],
        },
        {
          style: { groupStyle: "row" },
          fields: [
            {
              id: "percentage",
              label: "Percentage",
              Field_Name: "Percentage",
              fieldType: FormFieldTypes.NUMERIC,
              dataField: "percentage",
              fieldSetting: { placeholder: "Enter percentage", masked: { format: "00.00" } },
              validation: [
                { type: validationTypes.REQUIRE },
                { type: validationTypes.PERCENTAGE },
              ],
              style: { containerCss: "col-6 mb-2" },
            },
            ...(isHsc ? [getStreamField()] : []),
          ],
        },
      ],
    },
  ],
});
